import { FETCH_PLAN_STATUS } from '../store/modules/account'

export function getPlanStatus({ next, store }) {
    store.dispatch(`account/${FETCH_PLAN_STATUS}`, { root: true })
    return next()
}